import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Contexts/AuthContext";
import { auth } from "../../Services/firebase-config"

const ProtectedRoute = ({ children }) => {
    const { currentUser, userData, loading } = useAuth();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isEvent = searchParams.get('event') === 'true';
    const eventId = searchParams.get('eventId');

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-custom-blue-1"></div>
            </div>
        );
    }

    if (!auth.currentUser) {
        // Build the login URL with event parameters if present
        let loginUrl = "/login";
        if (isEvent) {
            loginUrl += `?event=true`;
            if (eventId) loginUrl += `&eventId=${eventId}`;
        }

        // Redirect to login if not authenticated
        return <Navigate to={loginUrl} state={{ from: location }} replace />;
    }

    // If user is authenticated, check their role for routing
    if (currentUser) {
        console.log("User is authenticated:", userData);

        // Handle Applicant role routing
        if (userData?.role === 'Applicant') {
            // Check if we have event parameters in URL or localStorage
            const hasEventParams = isEvent && eventId;
            const hasStoredEvent = localStorage.getItem('eventRedirect') === 'true' && localStorage.getItem('eventId');

            if (hasEventParams || hasStoredEvent) {
                const redirectEventId = eventId || localStorage.getItem('eventId') || 'a1b2c3d4-e5f6-7890-abcd-ef1234567890';
                return <Navigate to={`/hackathon-dashboard?event=true&eventId=${redirectEventId}`} state={{ from: location }} replace />;
            } else {
                return <Navigate to="/" state={{ from: location }} replace />;
            }
        }

        // For all other roles (Administrator, Judge, Mentor, etc.), allow access to the protected route
        return children;
    }

    // If not authenticated and no current user, redirect to login
    return <Navigate to="/login" state={{ from: location }} replace />;
};

export default ProtectedRoute;
